import { parseDateRange } from '../components/utils/dateUtils';

export const DASHBOARD_DATE_PRESET_OPTIONS = [
  { value: '1', label: 'Last 1 month' },
  { value: '3', label: 'Last 3 months' },
  { value: '6', label: 'Last 6 months' },
  { value: '12', label: 'Last 12 months' },
  { value: 'custom', label: 'Custom range' },
];

export const DEFAULT_DASHBOARD_DATE_PRESET = '3';

/** @param {string} [preset] */
export function getDashboardDatePresetLabel(preset) {
  const resolvedPreset = preset || DEFAULT_DASHBOARD_DATE_PRESET;
  const match = DASHBOARD_DATE_PRESET_OPTIONS.find(
    (option) => option.value === resolvedPreset
  );
  return match?.label ?? 'Last 3 months';
}

/**
 * @typedef {{ preset: string, customRange: any }} DashboardDateFilterState
 */

/** @returns {DashboardDateFilterState} */
export function createDefaultDashboardDateFilter() {
  return {
    preset: DEFAULT_DASHBOARD_DATE_PRESET,
    customRange: null,
  };
}

function formatDateQueryParam(dateValue) {
  if (!dateValue) return null;
  const date = dateValue._isAMomentObject
    ? dateValue.toDate()
    : new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Build axios query params for dashboard summary/charts endpoints.
 * @param {DashboardDateFilterState} filter
 * @returns {{ months?: string, from?: string, to?: string }}
 */
export function buildDashboardDateQueryParams(filter) {
  if (!filter) {
    return { months: DEFAULT_DASHBOARD_DATE_PRESET };
  }

  if (filter.preset === 'custom') {
    const { startDate, endDate } = parseDateRange(filter.customRange);
    const from = formatDateQueryParam(startDate);
    const to = formatDateQueryParam(endDate);
    if (from && to) {
      return { from, to };
    }
    return { months: DEFAULT_DASHBOARD_DATE_PRESET };
  }

  return { months: filter.preset || DEFAULT_DASHBOARD_DATE_PRESET };
}

/**
 * Stable string key for effect dependencies when refetching dashboard data.
 * @param {DashboardDateFilterState} filter
 */
export function dashboardDateFilterKey(filter) {
  const params = buildDashboardDateQueryParams(filter);
  return JSON.stringify(params);
}
